export default __webpack_public_path__ + "static/media/b1.2c5e868f.png";